export enum MessageSortType {
  SENT_ON = 'SENT_ON',
  NEW_MESSAGE = 'NEW_MESSAGE',
  NEW_MESSAGE_AND_SENT_ON = 'NEW_MESSAGE_AND_SENT_ON'
}
